import styled from 'styled-components';
import { SIZE, FONTS, COLORS } from '@app/src/ui';

export const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const DateWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const DateSelected = styled.div`
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f4f4f4;
  border: 1px solid ${COLORS.GRAY_PLACEHOLDER};
  box-shadow: 0px 3px 5px #00000029;
  margin: 4px;
  width: 130px;
  height: 30px;
  padding: 0 12px;

  span {
    line-height: 16px;
    margin-right: 5px;
    font-family: ${FONTS.ROBOTO};
    font-size: 14px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 136px;
    height: 40px;
    padding: 12px;
  }
`;

export const SubTitle = styled.span`
  display: block;
  font-family: ${FONTS.ROBOTO};
  font-size: 16px;
  color: ${COLORS.BLACK};
  margin-bottom: 15px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 23px;
  }
`;

export const Separator = styled.hr`
  border: 1px solid ${COLORS.GRAY_LIGHT};
  margin-bottom: 28px;
`;